<!--
 * @Author: 窦云飞 df1987131@yeah.net
 * @Date: 2023-07-12 09:01:04
 * @LastEditors: 窦云飞 df1987131@yeah.net
 * @LastEditTime: 2023-11-09 09:59:28
 * @FilePath: /epec-bidding/Users/douyunfei/Documents/epec-ea/src/modules/projectA/pages/ES/ESapply/productEvaluationInfo.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<!-- 产品质量评价信息 -->
<template>
  <div>
    <div class="form-container">
      <div class="form-title">我的产品评价</div>
      <eSteps :step-list="stepList" :is-active="isActive"></eSteps>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">订单信息</div>
      <orderInfo :apply-info="applyInfo"></orderInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">评价信息</div>
      <evaluationInfo
        :apply-id="applyId"
        :apply-status="applyStatus"
      ></evaluationInfo>
    </div>
    <!--    v-if="-->
    <!--    routeFrom === 'myApplyPage' &&-->
    <!--    (applyStatus !== 217 || applyStatus !== 218 || applyStatus !== 219)-->
    <!--    "-->
    <div
      v-if="
        routeFrom === 'myApplyPage' &&
        applyStatus !== 205 &&
        applyStatus !== 218 &&
        applyStatus !== 217 &&
        applyStatus !== 219 &&
        applyStatus !== 201
      "
      class="form-container"
    >
      <div class="form-title margin-b-20">供应商信息</div>
      <supplierInfo
        :apply-info="applyInfo"
        :apply-status="applyStatus"
        @changeConfirm="changeConfirm"
      ></supplierInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">产品质量评价申请人信息</div>
      <applyInfo :apply-info="applyInfo"></applyInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票信息详情</div>
      <invoiceDetailInfo :apply-id="applyId"></invoiceDetailInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">发票邮寄信息</div>
      <invoiceAddressInfo :apply-id="applyId"></invoiceAddressInfo>
    </div>
    <div v-if="applyInfo.isUploadAgreement" class="form-container">
      <div class="form-title margin-b-20">产品质量评价委托协议</div>
      <attachmentInfo :apply-info="applyInfo"></attachmentInfo>
    </div>
    <!-- <div class="form-container">
      <div class="form-title margin-b-20">审核历史</div>
      <auditHistoryInfo :applyInfo="applyInfo"></auditHistoryInfo>
    </div>
    <div class="form-container">
      <div class="form-title margin-b-20">审核信息</div>
      <auditForm ref="auditForm" :applyInfo="applyInfo"></auditForm>
    </div>
    <div class="btn-wrap">
      <eui-btn type="secondary" @click="submitApplyInfo">取消</eui-btn>
      <eui-btn type="primary" @click="submitApplyInfo">提交</eui-btn>
    </div> -->
    <div class="btn-wrap">
      <eui-btn type="secondary" @click="goBack">返回</eui-btn>
    </div>
  </div>
</template>

<script>
import eSteps from '../../../components/common/e-steps.vue';
import evaluationInfo from './component/evaluationInfo.vue';
import applyInfo from './component/applyInfo.vue';
import invoiceDetailInfo from './component/invoiceDetailInfo.vue';
import invoiceAddressInfo from './component/invoiceAddressInfo.vue';
// import auditHistoryInfo from './component/auditHistoryInfo.vue';
import orderInfo from './component/orderInfo.vue';
import attachmentInfo from './component/attachmentInfo.vue';
import supplierInfo from './component/supplierInfo.vue';
import api from '../../../api/evaluation/index';
import auditForm from './component/auditForm.vue';

export default {
  components: {
    eSteps,
    evaluationInfo,
    applyInfo,
    invoiceDetailInfo,
    invoiceAddressInfo,
    orderInfo,
    attachmentInfo,
    supplierInfo,
    // auditForm,
    // auditHistoryInfo
  },
  data() {
    return {
      handleConfirm: false, // 供应商 信息 里面的 勾选
      isActive: 1,
      stepList: [
        {
          id: 1,
          title: '提交申请',
        },
        {
          id: 2,
          title: '申请确认',
        },
        {
          id: 3,
          title: '支付完成',
        },
        {
          id: 4,
          title: '审核通过',
        },
        {
          id: 5,
          title: '评价完成',
        },
      ],
      applyInfo: {},
      fromRoute: {},
      routeFrom: null,
      applyId: null,
      applyStatus: null,
    };
  },

  computed: {},

  async created() {
    this.applyId = Number(this.$route.query.applyId);
    await this.getEvaluationInfo(this.applyId);
    this.routeFrom = this.$route.query.from;
    if (this.routeFrom === 'myApplyPage') {
      this.applyStatus = Number(this.$route.query.applyStatus);
      this.applyInfo.applyStatus = this.applyStatus;
    }
    if (this.applyStatus !== null && this.applyStatus === 208) {
      this.checkIsOpenOnlinePay();
    }

    await this.handleSteps(this.applyStatus, this.stepList);
  },
  methods: {
    changeConfirm(val) {
      this.handleConfirm = val;
    },
    //  评价申请人信息===========
    async getEvaluationInfo(applyId) {
      const res = await api.getEvaluationApplyDetail({ applyId });
      if (res.code === '200') {
        this.applyInfo = res.data;
      }
    },
    submitApplyInfo() {
      this.$refs.auditForm.submitForm((res) => {
        console.log(res);
      });
    },
    // 判断是否开通在线支付
    async checkIsOpenOnlinePay() {
      const res = await api.checkIsOpenOnlinePay();
      if (res.code === '200') {
        this.$set(this.applyInfo, 'isOnlinePay', res.data);
      }
    },
    // 处理步骤条展示
    handleSteps(status, stepList) {
      status = String(status);
      if (status === '219') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '申请驳回';
        stepList[1].description = this.applyInfo.flowTime110
          ? this.applyInfo.flowTime110
          : this.applyInfo.flowTime114;
        this.isActive = 1;
      }
      if (status === '218') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].description = this.applyInfo.flowTime114;

        this.isActive = 2;
      }
      if (status === '205' || status === '217') {
        stepList[0].description = this.applyInfo.flowTime101;
        this.isActive = 0;
      }
      // 待支付
      if (status === '208') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '待支付';
        this.isActive = 2;
      }
      // 支付中
      if (status === '209') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付中';
        stepList[2].description = this.applyInfo.flowTime102;
        this.isActive = 2;
      }
      // 支付失败
      if (status === '210') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付失败';
        stepList[2].description = this.applyInfo.flowTime102;
        this.isActive = 2;
      }
      // 资料初审
      if (status === '206') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付完成';
        stepList[2].description = this.applyInfo.flowTime102;
        stepList[3].title = '资料初审';
        this.isActive = 3;
      }
      // 资料初审驳回
      if (status === '207') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付完成';
        stepList[2].description = this.applyInfo.flowTime102;
        stepList[3].title = '审核驳回';
        stepList[3].description = this.applyInfo.flowTime103;
        this.isActive = 3;
      }
      // 资料复审
      if (status === '214') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付完成';
        stepList[2].description = this.applyInfo.flowTime102;
        stepList[3].title = '资料复审';
        stepList[3].description = this.applyInfo.flowTime103;
        this.isActive = 3;
      }
      // 资料复审
      if (status === '211') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付完成';
        stepList[2].description = this.applyInfo.flowTime102;
        stepList[3].title = '审核通过';
        //  stepList[3].description = this.applyInfo.flowTime103;
        stepList[4].title = '评价中';
        this.isActive = 4;
      }
      // 资料复审
      if (status === '212') {
        stepList[0].description = this.applyInfo.flowTime101;
        stepList[1].title = '提交确认';
        stepList[1].description = this.applyInfo.flowTime110;
        stepList[2].title = '支付完成';
        stepList[2].description = this.applyInfo.flowTime102;
        stepList[3].title = '审核通过';
        //  stepList[3].description = this.applyInfo.flowTime103;
        stepList[4].title = '评价完成';
        this.isActive = 5;
      }

      // 订单 关闭
      if (status === '213') {
        this.isActive = null;
      }
    },
    goBack() {
      this.$router.go(-1);
    },
  },
};
</script>
<style lang="scss" scoped>
.margin-b-20 {
  margin-bottom: 20px;
}

.btn-wrap {
  text-align: left;
}
</style>
